var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDocumentation1 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "23px",
    viewBox: "0 0 24 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BE0D7376-FE86-4561-BB2C-F01105DAAC17") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.290222 0 0 0 0 0.290175 0 0 0 0 0.290237 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wireframes-2.0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "11.0-Help-Center",
    transform: "translate(-787.000000, -433.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "documentation",
    transform: "translate(735.000000, 392.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.000000, 52.500000) scale(-1, 1) translate(-64.000000, -52.500000) translate(52.000000, 41.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.201373,13 L8.40961098,13 C9.07311097,13 9.61098398,12.3284271 9.61098398,11.5 C9.61098398,10.6715729 9.07311097,10 8.40961098,10 L1.201373,10 C0.537873012,10 0,10.6715729 0,11.5 C0,12.3284271 0.537873012,13 1.201373,13 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.201373,3 L8.40961098,3 C9.07311097,3 9.61098398,2.32842712 9.61098398,1.5 C9.61098398,0.671572875 9.07311097,0 8.40961098,0 L1.201373,0 C0.537873012,0 0,0.671572875 0,1.5 C0,2.32842712 0.537873012,3 1.201373,3 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.201373,23 L8.40961098,23 C9.07311097,23 9.61098398,22.3284271 9.61098398,21.5 C9.61098398,20.6715729 9.07311097,20 8.40961098,20 L1.201373,20 C0.537873012,20 0,20.6715729 0,21.5 C0,22.3284271 0.537873012,23 1.201373,23 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.798627,10 L15.590389,10 C14.926889,10 14.389016,10.6715729 14.389016,11.5 C14.389016,12.3284271 14.926889,13 15.590389,13 L22.798627,13 C23.462127,13 24,12.3284271 24,11.5 C24,10.6715729 23.462127,10 22.798627,10 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.798627,0 L15.590389,0 C14.926889,0 14.389016,0.671572875 14.389016,1.5 C14.389016,2.32842712 14.926889,3 15.590389,3 L22.798627,3 C23.462127,3 24,2.32842712 24,1.5 C24,0.671572875 23.462127,0 22.798627,0 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.798627,20 L15.590389,20 C14.926889,20 14.389016,20.6715729 14.389016,21.5 C14.389016,22.3284271 14.926889,23 15.590389,23 L22.798627,23 C23.462127,23 24,22.3284271 24,21.5 C24,20.6715729 23.462127,20 22.798627,20 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDocumentation1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/documentation1.c8bc58034ea8d83b54f084fd517a468f.svg";